// extracted by mini-css-extract-plugin
export default {"container":"ripple_container__Q7c9J","ripple":"ripple_ripple__yg+md"};